import { render, staticRenderFns } from "./ControleGaiolaRetorno.vue?vue&type=template&id=fcb4c90a&scoped=true"
import script from "./ControleGaiolaRetorno.vue?vue&type=script&lang=js"
export * from "./ControleGaiolaRetorno.vue?vue&type=script&lang=js"
import style0 from "./ControleGaiolaRetorno.vue?vue&type=style&index=0&id=fcb4c90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb4c90a",
  null
  
)

export default component.exports